import cx from 'classnames';
import { darkTheme, lightTheme } from '~/theme.css';
import * as styles from './Login.css';
import { useTheme } from './utils/store';
import { getAuthURL } from './utils/utils';

const redirect = window.location.origin;
const url = getAuthURL(redirect);

function Login() {
  const theme = useTheme();
  return (
    <div
      className={cx({
        [darkTheme]: theme === 'dark',
        [lightTheme]: theme === 'light',
      })}
      style={{ width: '100%', height: '100%' }}
    >
      <div className={styles.loginContainer}>
        <div className={styles.header}>
          <a href="/" className={styles.logo}>
            <img
              src="https://youneedawiki.com/img/icon/icon.svg"
              alt="Logo"
              className={styles.logoIcon}
              width="32"
              height="32"
            />
            You Need A Wiki
          </a>
        </div>
        <div className={styles.content}>
          <h1 className={styles.title}>Sign in</h1>
          <a href={url} className={styles.googleButton}>
            <span className={styles.googleIcon}>
              <svg width="18" height="18" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" aria-hidden="true">
                <title>Google</title>
                <path
                  fill="#EA4335"
                  d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"
                />
                <path
                  fill="#4285F4"
                  d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"
                />
                <path
                  fill="#FBBC05"
                  d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"
                />
                <path
                  fill="#34A853"
                  d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"
                />
                <path fill="none" d="M0 0h48v48H0z" />
              </svg>
            </span>
            Sign in with Google
          </a>
          <div className={styles.infoText}>
            <svg
              className={styles.checkIcon}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <title>Check</title>
              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z" fill="#5B76F5" />
            </svg>
            YNAW server does not store your files or folders.
          </div>
          <a
            target="_blank"
            rel="noreferrer"
            href="https://youneedawiki.com/permissions.html"
            className={styles.permissionsLink}
          >
            <svg
              className={styles.lockIcon}
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <title>Lock</title>
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
                fill="#22275A"
              />
            </svg>
            Read more about permissions
          </a>
        </div>
      </div>
    </div>
  );
}

export default Login;
